import { FormInputField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CountrySelectField } from '../../../../../../components/form/hookFields';

/**
 *  We can't use the generic AddressFields component because we want:
 * - The label of the AddressLine1 to say "Legal business address".
 * - The address lines should have specific placeholders.
 *
 * These differences are important to make sure users fill in the right info.
 */
export const BrandRegistrationAddressFields = () => (
    <>
        <FormInputField
            name="addressLine1"
            label={<LocalizedText textKey={TextKey.LegalBusinessAddress} />}
            placeholder={<LocalizedText textKey={TextKey.LegalBusinessAddressPlaceholder} />}
            required
        />

        <FormInputField
            name="addressLine2"
            label={<LocalizedText textKey={TextKey.AddressLine2} />}
            placeholder={<LocalizedText textKey={TextKey.AddressLine2Placeholder} />}
        />

        <FormInputField name="city" label={<LocalizedText textKey={TextKey.City} />} required />

        <FormInputField name="postalCode" label={<LocalizedText textKey={TextKey.PostalCode} />} required />

        <CountrySelectField
            countryFieldName="countryCode"
            countrySubdivisionFieldName="countrySubdivisionCode"
            required={{
                countryCode: true,
                countrySubdivisionCode: true,
            }}
        />
    </>
);
